var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-overlay',{staticStyle:{"z-index":"99999999"},attrs:{"value":_vm.LoaderSaleMan}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"#2A70C3"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }